<template>
  <div>
    <template>
      <div>
        <v-card light>
          <v-system-bar dark color="grey darken-1" height="50">
            <v-btn
              outlined
              small
              fab
              dark
              class="transparent"
              @click.stop="$router.go(-1)"
            >
              <v-icon>mdi-arrow-left-circle</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            Formations de masse
            <v-spacer></v-spacer>

            <v-btn
              outlined
              small
              fab
              dark
              class="transparent"
              @click.stop="$router.go(-1)"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-system-bar>

       
          <v-card-text>
            <v-list two-line subheader>
              <v-list-item
                v-for="(formation, index) in FormationsDeMasse"
                :key="index"
              >
                  <v-list-item-content>
                <v-list-item-title>{{
                  formation.ll_formation
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  formation.date_formation
                }}</v-list-item-subtitle>
                 <v-list-item-subtitle>Nombre de participants : {{
                  formation.nombre_participants
                }}</v-list-item-subtitle>
                  </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon>
                    <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>

        
          </v-card-text>
      
        </v-card>
      </div>
    </template>
      <Navigation :elements="SuperviseurNavigation" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  components: {
    Navigation: require("@/components/Navigation.vue").default,
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "Formation", value: "ll_formation" },
        { text: "Participants", value: "nombre_participants" },
        { text: "Activité", value: "ll_parcours" },
        { text: "Date", value: "date_formation" },
        { text: "Responsable", value: "nom_responsable" },
        {
          text: "Région",
          value: "ll_region",
        },
        {
          text: "District",
          value: "ll_district",
        },
        {
          text: "Commune",
          value: "ll_commune",
        },
        {
          text: "Fokontany",
          value: "ll_fokontany",
        },
        {
          text: "Thème",
          value: "ll_theme",
        },
      ],
    };
  },
  created() {
   
  },

  computed: {
    ...mapState({
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      user: (state) => state.Auth.user,
      FormationsDeMasse: (state) => state.FormationsDeMasse.FormationsDeMasse,
    }),
  },
  methods: {
    ...mapActions({
   
    }),
  },
};
</script>

<style lang="scss" scoped></style>
